import { ConfigFormSetupISACustomSegments } from './components/ConfigFormSetupISACustomSegments';

export const SetupISACustomSegments = () => {
  return (
    <div>
      <ConfigFormSetupISACustomSegments />
    </div>
  );
};
